import WorkflowNodeDomainService from "../WorkflowNode/WorkflowNode.service";
import { WorkflowGroupDomainService } from "../WorkflowGroup/WorkflowGroup.service";
export default class WorkflowDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { createdDate: json.createdDate && new Date(json.createdDate), expirationDate: json.expirationDate && new Date(json.expirationDate), rootNode: json.rootNode && WorkflowNodeDomainService.fromJSON(json.rootNode), nodes: json.nodes &&
                // @ts-expect-error - TS7006 - Parameter 'node' implicitly has an 'any' type.
                json.nodes.map((node) => WorkflowNodeDomainService.fromJSON(node)), workflowGroup: json.workflowGroup &&
                WorkflowGroupDomainService.fromJSON(json.workflowGroup) });
    }
}
